import { jsx as _jsx } from "react/jsx-runtime";
import { queryClient as browserQueryClient } from '@as-react/common-queries';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
const resolveQueryClient = (queryClient) => {
    if (queryClient)
        return queryClient;
    if (typeof window === 'undefined') {
        throw new Error('WrapWithQueryContext requires an explicit per-request queryClient on the server; falling back to the shared singleton would leak every render into it.');
    }
    return browserQueryClient;
};
export const WrapWithQueryContext = (BaseComponent, { dehydratedState, queryClient }) => {
    const resolvedQueryClient = resolveQueryClient(queryClient);
    return function QueryContextWrapper(props) {
        return (_jsx(QueryClientProvider, { client: resolvedQueryClient, children: _jsx(HydrationBoundary, { state: dehydratedState, children: _jsx(BaseComponent, { ...props }) }) }));
    };
};
